import type { FC } from "react";
import { Handle, Position } from "@xyflow/react";

const hidden = {
  opacity: 0,
  pointerEvents: "none" as const,
  width: 1,
  height: 1,
};

/** Hidden RF handles. `targetTopOffset` skips section labels ("When/Then")
 *  so step edges land on the card top, not above the header text. */
export const HiddenHandles: FC<{ targetTopOffset?: number }> = ({
  targetTopOffset = 0,
}) => (
  <>
    <Handle
      type="target"
      position={Position.Top}
      style={targetTopOffset > 0 ? { ...hidden, top: targetTopOffset } : hidden}
      isConnectable={false}
    />
    <Handle
      type="source"
      position={Position.Bottom}
      style={hidden}
      isConnectable={false}
    />
  </>
);
